<script lang="ts">
  import TradingCanvasBackground from '$lib/components/login/TradingCanvasBackground.svelte';
  import { Button } from '$lib/components/ui/button';

  type Density = 'low' | 'medium' | 'high';
  type Speed = 'slow' | 'normal' | 'fast';

  let density = $state<Density>('medium');
  let speed = $state<Speed>('normal');
  let interactive = $state(true);

  // Forzamos remount del canvas cuando cambian las opciones para reseed.
  let nonce = $state(0);
  function applyChanges(): void {
    nonce++;
  }
</script>

<div class="bg-background relative min-h-screen overflow-hidden">
  {#key nonce}
    <TradingCanvasBackground {density} {speed} {interactive} />
  {/key}

  <!-- Overlay para legibilidad -->
  <div class="absolute inset-0 bg-black/55 backdrop-blur-[1px]"></div>

  <main class="relative z-10 flex min-h-screen flex-col items-center justify-center gap-8 px-4">
    <div class="text-center">
      <h1 class="text-3xl font-semibold tracking-tight text-white">TradingCanvasBackground</h1>
      <p class="mt-2 text-sm text-white/70">Live demo. If you like it, we'll ship it on the Login screen.</p>
    </div>

    <div
      class="grid w-full max-w-2xl grid-cols-1 gap-3 rounded-2xl border border-white/10 bg-black/45 p-6 shadow-2xl backdrop-blur-xl sm:grid-cols-3"
    >
      <div class="flex flex-col gap-1.5">
        <label for="density" class="text-xs font-medium text-white/70">Density</label>
        <select
          id="density"
          bind:value={density}
          onchange={applyChanges}
          class="h-9 rounded-md border border-white/15 bg-black/40 px-3 text-sm text-white"
        >
          <option value="low">Low</option>
          <option value="medium">Medium</option>
          <option value="high">High</option>
        </select>
      </div>

      <div class="flex flex-col gap-1.5">
        <label for="speed" class="text-xs font-medium text-white/70">Speed</label>
        <select
          id="speed"
          bind:value={speed}
          onchange={applyChanges}
          class="h-9 rounded-md border border-white/15 bg-black/40 px-3 text-sm text-white"
        >
          <option value="slow">Slow</option>
          <option value="normal">Normal</option>
          <option value="fast">Fast</option>
        </select>
      </div>

      <div class="flex flex-col gap-1.5">
        <span class="text-xs font-medium text-white/70">Interactive</span>
        <Button
          variant={interactive ? 'default' : 'outline'}
          size="sm"
          onclick={() => {
            interactive = !interactive;
            applyChanges();
          }}
        >
          {interactive ? 'On' : 'Off'} (mouse parallax)
        </Button>
      </div>
    </div>

    <p class="max-w-xl text-center text-xs text-white/50">
      The animation respects prefers-reduced-motion. Resize is debounced 100ms. DevicePixelRatio
      handled. Cleanup on unmount.
    </p>
  </main>
</div>
